var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[_c('Banner'),_c('Article',{attrs:{"title":'Miles Everson’s Business Builder Daily',"body":_vm.main,"subscribe":true,"panels":_vm.panels,"id":"newsletter"}}),_c('SubscriptionForm')],1)}
var staticRenderFns = []

export { render, staticRenderFns }